import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@core';

@Component({
    selector: 'app-downtime-dialog',
    templateUrl: './downtime-dialog.component.html',
    styleUrls: ['./downtime-dialog.component.scss'],
    standalone: false
})
export class DowntimeDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<DowntimeDialogComponent>,
    public readonly authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data?: any,
  ) { }
  public maintenanceMessage = this.data?.message;
  public maintenanceTitle = this.data?.title;
  close() {
    if (this.data.outageFlag == true) {
      this.authService.logout();
    } else {
      this.dialogRef.close();
    }
  }

}
